import { PortfolioModel } from "../types/PortfolioModel";
import { UnderlyingAssetModel } from "../types/UnderlyingAssetModel";
import { portfolioMappers } from "../../../shared/mappers/PortfolioMappers";
import { AllPortfoliosConstants } from "../constants/AllPortfoliosConstants";
import { PortfolioGroupModel } from "../types/PortfolioGroupModel";

class AllPortfoliosBuilder {
    build(
        portfolios: PortfolioModel[],
        underlyingAsset: UnderlyingAssetModel,
        portfolioGroup: PortfolioGroupModel,
    ): PortfolioModel {
        const firstPortfolio = portfolios[0] ?? null;
        const defaultDate = new Date();
        const portfolioSettings = portfolioGroup.portfolioSettings !== null
            ? portfolioMappers.mapSettingsModelToModel(portfolioGroup.portfolioSettings)
            : null;

        return {
            id: AllPortfoliosConstants.Id,
            name: AllPortfoliosConstants.Name,
            description: "All portfolios for the selected underlying asset",
            marginBuffer: firstPortfolio?.marginBuffer ?? 0,
            inceptionDate: firstPortfolio?.inceptionDate ?? defaultDate,
            useValuationDate: firstPortfolio?.useValuationDate ?? false,
            valuationDate: firstPortfolio?.valuationDate ?? defaultDate,
            underlyingAsset,
            portfolioGroup: portfolioMappers.mapPortfolioGroupModelToModel(portfolioGroup),
            positions: portfolios.reduce((items, portfolio) => items.concat(portfolio.positions), [] as PortfolioModel["positions"]),
            orders: portfolios.reduce((items, portfolio) => items.concat(portfolio.orders), [] as PortfolioModel["orders"]),
            portfolioBalanceHistory: [],
            portfolioSettings,
            modifiedAt: null,
        };
    }
}

export const allPortfoliosBuilder = new AllPortfoliosBuilder();
